import { Type } from '@angular/core';
import { BaseWidgetComponent } from '@common-modules/shared/component/base-widget.component';
import { ComponentHelperService } from '@common-modules/shared/helpers/component-helper.service';

export class TabDetailPanelSettings {
  components: Type<BaseWidgetComponent>[] = [];
  titlesByKey: Map<string, string>;
  titlesByOrder: Map<number, string>;
  showHeaders = true;
  isDashboardContainer = false;

  constructor(data?: { isDashboardContainer }) {
    this.isDashboardContainer = data?.isDashboardContainer ?? false;

    this.titlesByKey = new Map<string, string>();
    this.titlesByOrder = new Map<number, string>();
  }

  public addComponent(component: Type<BaseWidgetComponent>, title: string = null) {
    const index = this.components.push(component);
    const componentName = ComponentHelperService.getWidgetName(component);
    const componentTitle = title ?? componentName;
    this.titlesByOrder.set(index, componentTitle);
    this.titlesByKey.set(componentName, componentTitle);
  }
}
